import { Box } from "@chakra-ui/react";
import { arc } from "d3-shape";
import { scaleLinear } from "d3-scale";

// Resource - https://wattenberger.com/blog/gauge

const getCoordsOnArc = (angle, offset = 10) => [
  Math.cos(angle - Math.PI / 2) * offset,
  Math.sin(angle - Math.PI / 2) * offset,
];

export default function PaymentDueGauge({
  value = new Date(),
  createdAt = new Date(2022, 0, 1),
  dueAt = new Date(2022, 0, 30),
  label,
  units,
}) {
  const backgroundArc = arc()
    .innerRadius(0.9)
    .outerRadius(1)
    .startAngle(-Math.PI / 2)
    .endAngle(Math.PI / 2)
    .cornerRadius(1)();

  const percentScale = scaleLinear().domain([createdAt, dueAt]).range([0, 1]);
  const percent = percentScale(value);

  const angleScale = scaleLinear()
    .domain([0, 1])
    .range([-Math.PI / 2, Math.PI / 2])
    .clamp(true);
  const angle = angleScale(percent);

  const filledArc = arc()
    .innerRadius(0.9)
    .outerRadius(1)
    .startAngle(-Math.PI / 2)
    // .endAngle(angle)
    .endAngle(Math.PI / 2)
    .cornerRadius(1)();

  const colorScale = scaleLinear()
    .domain([-1, 0, 1])
    .range(["#03A438", "yellow", "red"]);
  const gradientSteps = colorScale.ticks(10).map((value) => colorScale(value));

  const pointerScale = scaleLinear().domain([0, 1]).range([0, 180]).clamp(true);
  const pointerAngle = pointerScale(percent);

  const markerColorScale = scaleLinear()
    .domain([0, 1])
    .range(["#03A438", "red"]);
  const markerLocation = getCoordsOnArc(angle, 1 - (1 - 0.9) / 2);

  // const PaymentInfo = () => {
  //   return (
  //     <Stack>
  //       <Text>2 more days to go.</Text>
  //     </Stack>
  //   );
  // };

  return (
    <Box pos="relative" mb="80px">
      <Box
        as="svg"
        width="100%"
        viewBox={[-1, -1, 2, 1].join(" ")}
        style={{
          //   border: "1px solid pink",
          overflow: "visible",
        }}
      >
        <defs>
          <linearGradient
            id="Gauge__gradient"
            gradientUnits="userSpaceOnUse"
            x1="-1"
            x2="1"
            y2="0"
          >
            {gradientSteps.map((color, index) => (
              <stop
                key={color}
                stopColor={color}
                offset={`${index / (gradientSteps.length - 1)}`}
              />
            ))}
          </linearGradient>
          {/* <linearGradient
            id="Gauge__gradient"
            x1="-1"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
             Generated from https://learnui.design/tools/gradient-generator.html 
            <stop offset="0" stop-color="#03a438" />
            <stop offset="0.16666666666666666" stop-color="#11bb06" />
            <stop offset="0.3333333333333333" stop-color="#63d00a" />
            <stop offset="0.5" stop-color="#c2e50f" />
            <stop offset="0.6666666666666666" stop-color="#edbf22" />
            <stop offset="0.8333333333333333" stop-color="#eb813d" />
            <stop offset="1" stop-color="#eb5757" />
          </linearGradient> */}
        </defs>
        <path d={backgroundArc} fill="#dbdbe7" />
        <path d={filledArc} fill="url(#Gauge__gradient)" />

        {/* <Tooltip hasArrow label={<PaymentInfo />}> */}
        <Box
          as="circle"
          cx={markerLocation[0]}
          cy={markerLocation[1]}
          r="0.035"
          stroke="white"
          strokeWidth="0.005"
          fill={markerColorScale(percent)}
          transition="all .3s ease-in-out"
          _hover={{
            r: ".04",
            strokeWidth: "0.008",
            transition: "all .3s ease-in-out",
          }}
        />
        {/* </Tooltip> */}
      </Box>
      <Box
        // bg="transparent"
        // bgImage="url(`data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%233B920CFF' stroke-width='3' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e`)"
        pos="absolute"
        top="40px"
        left="50%"
        boxSize="70%"
        border="1px dashed green"
        borderBottomColor="transparent"
        borderRadius="150px 150px 0 0"
        transform={`translateX(-50%)`}
      ></Box>
      <Box
        bg="white"
        boxSize="80px"
        shadow="base"
        borderRadius="50%"
        pos="absolute"
        bottom="-40px"
        left="50%"
        transform={`translateX(-50%)`}
      >
        <Box
          pos="absolute"
          left="50%"
          top="50%"
          //   remapped from [-(Math.PI / 2)  (Math.PI / 2)] to [0, 180] degs
          transform={`translate(-50%, -50%) rotate(${pointerAngle}deg)`}
        >
          <Box
            pos="absolute"
            left="50%"
            top="50%"
            transform="translate(-50%, -50%) rotate(-45deg)" // sets the pointer origin to -Math.PI / 2
          >
            <Box
              as="svg"
              boxSize="60px"
              viewBox="0 0 41 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.4798 40.0195C9.75716 40.0195 0.889973 31.1523 0.889973 20.4297C0.889973 9.6875 9.75716 0.839844 20.4993 0.839844C31.222 0.839844 40.0697 9.6875 40.0697 20.4297C40.0697 31.1523 31.2025 40.0195 20.4798 40.0195ZM20.4798 37.4805C29.9329 37.4805 37.5306 29.8633 37.5306 20.4297C37.5306 10.9766 29.9329 3.35938 20.4993 3.35938C11.0462 3.35938 3.42904 10.9766 3.4095 20.4297C3.4095 29.8633 11.0267 37.4805 20.4798 37.4805ZM20.4993 10.332C19.5228 10.332 18.7025 9.53125 18.7025 8.55469C18.7025 7.55859 19.5228 6.75781 20.4993 6.75781C21.4759 6.75781 22.2767 7.55859 22.2767 8.55469C22.2767 9.53125 21.4759 10.332 20.4993 10.332ZM23.3118 23.0469C21.8665 24.4531 19.9329 24.1211 18.7025 22.4414L10.5384 11.582C9.91341 10.7227 10.7923 9.88281 11.6322 10.4688L22.7454 18.3984C24.4251 19.5898 24.7572 21.582 23.3118 23.0469ZM28.8587 13.9062C27.8822 13.9062 27.0814 13.0859 27.0814 12.1094C27.0814 11.1328 27.8822 10.332 28.8587 10.332C29.8353 10.332 30.6556 11.1328 30.6556 12.1094C30.6556 13.0859 29.8353 13.9062 28.8587 13.9062ZM32.3353 22.2266C31.3587 22.2266 30.5579 21.4062 30.5579 20.4297C30.5579 19.4531 31.3587 18.6523 32.3353 18.6523C33.3118 18.6523 34.1322 19.4531 34.1322 20.4297C34.1322 21.4062 33.3118 22.2266 32.3353 22.2266ZM8.64388 22.2266C7.66732 22.2266 6.847 21.4062 6.847 20.4297C6.847 19.4531 7.66732 18.6523 8.64388 18.6523C9.62044 18.6523 10.4212 19.4531 10.4212 20.4297C10.4212 21.4062 9.62044 22.2266 8.64388 22.2266ZM28.8392 30.5469C27.8431 30.5469 27.0423 29.7461 27.0423 28.7695C27.0423 27.7734 27.8431 26.9727 28.8392 26.9727C29.8158 26.9727 30.6361 27.7734 30.6361 28.7695C30.6361 29.7461 29.8158 30.5469 28.8392 30.5469ZM12.14 30.5469C11.1634 30.5469 10.3626 29.7461 10.3626 28.7695C10.3626 27.7734 11.1634 26.9727 12.14 26.9727C13.1361 26.9727 13.9368 27.7734 13.9368 28.7695C13.9368 29.7461 13.1361 30.5469 12.14 30.5469Z"
                fill="#323232"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
